import React from 'react';

import { useQueryParam } from '@atlassian/jira-router';

import { useSelectedConfigTab, useIsUserLocatedBoard } from '../../controllers';

export const LastOpenedConfigTab = ({ configParam }: { configParam: string }) => {
	const [, setConfigParam] = useQueryParam('config');
	const { getSelectedConfigTab, setSelectedConfigTab } = useSelectedConfigTab();
	const isUserLocatedBoard = useIsUserLocatedBoard();

	const defaultTab = 'filter';
	const selectedTab = getSelectedConfigTab();
	const lastOpenedTab = selectedTab ? JSON.parse(selectedTab) : defaultTab;

	if (
		isUserLocatedBoard &&
		configParam === 'insightsConfig' &&
		lastOpenedTab === 'insightsConfig'
	) {
		setConfigParam(defaultTab);
		setSelectedConfigTab(defaultTab);
		return <></>;
	}

	setConfigParam(lastOpenedTab);
	return <></>;
};
